import { TAccount, TAccountType, TColor, TCurrency, TIcon } from "@/api/v1_0";
import { JSONSchema, validateData } from "@/validation";
import {
  Enum,
  Min,
  MinLength,
  NotNullable,
  Number,
  Optional,
  Required,
  Rules,
  Same,
  Uuid,
} from "@/validation/rules";
import { Color } from "./color";
import { Currency } from "./currency";
import { Icon } from "./icons";

export namespace Goal {
  export interface IInput extends Partial<TAccount> {
    uuid?: string;
    type: TAccountType;
    name?: string;
    currency?: TCurrency;
    icon?: TIcon;
    color?: TColor;
    balance?: number;
    limitation?: number;
  }

  export interface IErrors {
    uuid?: string;
    type?: string;
    name?: string;
    currency?: string;
    icon?: string;
    color?: string;
    balance?: string;
    limitation?: string;
  }

  export const create = (currency: TCurrency): IInput => ({
    balance: 0,
    currency,
    limitation: 0,
    type: TAccountType.Goal,
  });

  const validationRules: JSONSchema<IInput> = {
    type: "object",
    properties: {
      uuid: Rules(Optional(), Uuid()),
      type: Rules(Required(), Same(TAccountType.Goal)),
      name: Rules(Required(), NotNullable(), MinLength(1)),
      balance: Rules(Optional(), Number(), Min(0)),
      limitation: Rules(Optional(), Number(), Min(0)),
      currency: Rules(Required(), Enum(Currency.currencies)),
      icon: Rules(Optional(), Enum(Icon.icons)),
      color: Rules(Optional(), Enum(Color.colors)),
    },
  };

  export const validate = (input: IInput) =>
    validateData<IInput, IErrors, TAccount>(input, validationRules);
}
